import { Navigate } from "react-router-dom";

import usePermissions from "../../hooks/usePermissions";

/**
 * PERMISSION ROUTE
 *
 * IMPORTANT:
 * Frontend permissions are ONLY for UX.
 * Backend remains the real security layer.
 */
export default function PermissionRoute({
  permission,
  children,
  fallback = "/dashboard",
}) {
  const { can } = usePermissions();

  /**
   * NO PERMISSION
   */
  if (!can(permission)) {
    return <Navigate to={fallback} replace />;
  }

  /**
   * ALLOWED
   */
  return children;
}
